import type { ButtonGroupInjection } from './ButtonGroup'
import { createInjectionKey } from '../../_utils'

export const buttonGroupInjectionKey
  = createInjectionKey<ButtonGroupInjection>('n-button-group')
